import { render, staticRenderFns } from "./CollectionDetailModal.vue?vue&type=template&id=24926e8c&scoped=true&"
import script from "./CollectionDetailModal.vue?vue&type=script&lang=js&"
export * from "./CollectionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetailModal.vue?vue&type=style&index=0&id=24926e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24926e8c",
  null
  
)

export default component.exports